// Centralized asset configuration
// This file consolidates all S3 asset URLs to prevent hardcoding throughout the codebase

const ASSETS_BASE_URL = process.env.REACT_APP_ASSETS_URL || 'https://trademagic-assets.s3.us-west-1.amazonaws.com';
const CARDS_CDN_URL = process.env.REACT_APP_CARDS_URL || 'https://d3dmfym8zvsq5m.cloudfront.net';

export const AssetUrls = {
  base: ASSETS_BASE_URL,
  cardsCDN: CARDS_CDN_URL,
  
  // Font assets
  fonts: {
    belerenBold: `${ASSETS_BASE_URL}/assets/fonts/Beleren2016-Bold.ttf`,
  },
  
  // Icon assets
  icons: {
    mana: {
      white: `${ASSETS_BASE_URL}/assets/icons/mana_white.png`,
      blue: `${ASSETS_BASE_URL}/assets/icons/mana_blue.png`,
      black: `${ASSETS_BASE_URL}/assets/icons/mana_black.png`,
      red: `${ASSETS_BASE_URL}/assets/icons/mana_red.png`,
      green: `${ASSETS_BASE_URL}/assets/icons/mana_green.png`,
      colorless: `${ASSETS_BASE_URL}/assets/icons/mana_colorless.png`,
      generic: (num: number) => `${ASSETS_BASE_URL}/assets/icons/mana_${num}.png`,
      tap: `${ASSETS_BASE_URL}/assets/icons/mana_tap.png`,
      phyrexian: {
        white: `${ASSETS_BASE_URL}/assets/icons/mana_phyrexian_white.png`,
        blue: `${ASSETS_BASE_URL}/assets/icons/mana_phyrexian_blue.png`,
        black: `${ASSETS_BASE_URL}/assets/icons/mana_phyrexian_black.png`,
        red: `${ASSETS_BASE_URL}/assets/icons/mana_phyrexian_red.png`,
        green: `${ASSETS_BASE_URL}/assets/icons/mana_phyrexian_green.png`,
      },
      hybrid: (colors: string) => `${ASSETS_BASE_URL}/assets/icons/mana_${colors}.png`,
    },
    arrows: {
      send: `${ASSETS_BASE_URL}/assets/icons/icon-send-arrow.png`,
      receive: `${ASSETS_BASE_URL}/assets/icons/icon-receive-arrow.png`,
    },
    controls: {
      sort: `${ASSETS_BASE_URL}/assets/icons/sort.svg`,
      images: `${ASSETS_BASE_URL}/assets/icons/images.svg`,
      list: `${ASSETS_BASE_URL}/assets/icons/list.svg`,
    },
    navigation: {
      collection: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-collection.png`,
      sending: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-sending.png`,
      receiving: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-receiving.png`,
      search: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-search.png`,
      settings: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-settings.png`,
      guide: `${ASSETS_BASE_URL}/assets/icons/guide.svg`,
      sendingSvg: `${ASSETS_BASE_URL}/assets/icons/navigation/sending-icon.svg`,
      adminUsers: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-admin-users.svg`,
      adminCards: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-admin-cards.svg`,
      adminCases: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-admin-cases.svg`,
      adminTrades: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-admin-trades.svg`,
      adminTransactions: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-admin-transactions.svg`,
      adminFeedback: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-admin-feedback.svg`,
      adminCronJobs: `${ASSETS_BASE_URL}/assets/icons/clock.svg`,
      adminHome: `${ASSETS_BASE_URL}/assets/icons/dashboard.svg`,
      controls: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-collection.png`,
      admin: `${ASSETS_BASE_URL}/assets/icons/navigation/icon-admin.svg`,
    },
    dropdowns: {
      arrowUp: `${ASSETS_BASE_URL}/assets/icons/dropdowns/Arrow-up.png`,
      arrowDown: `${ASSETS_BASE_URL}/assets/icons/dropdowns/Arrow-down.png`,
      close: `${ASSETS_BASE_URL}/assets/icons/dropdowns/close.svg`,
      dropdownArrow: `${ASSETS_BASE_URL}/assets/icons/ViewCard/dropdown-arrow.svg`,
      arrowRight: `${ASSETS_BASE_URL}/assets/icons/ViewCard/arrow-right.svg`,
    },
    profile: {
      coin: `${ASSETS_BASE_URL}/assets/icons/profile/coin.svg`,
    },
    footer: {
      contact: `${ASSETS_BASE_URL}/assets/icons/Footer/icon-contact.png`,
      cards: `${ASSETS_BASE_URL}/assets/icons/Footer/Footer_cards.png`,
    },
    misc: {
      tradeStatusBar: `${ASSETS_BASE_URL}/assets/icons/icon-tradestatus-bar.png`,
      circleCheck: `${ASSETS_BASE_URL}/assets/icons/icon-circle-check.png`,
      plane: `${ASSETS_BASE_URL}/assets/icons/icon-plane.png`,
      settings: `${ASSETS_BASE_URL}/assets/icons/setting-icon.png`,
      settingsAlt: `${ASSETS_BASE_URL}/assets/icons/icon-setting.png`,
      notificationBadge: `${ASSETS_BASE_URL}/assets/icons/icon-notification-badge.png`,
      greenCheckCircle: `${ASSETS_BASE_URL}/assets/icons/green-check-circle.png`,
      heart: `${ASSETS_BASE_URL}/assets/icons/heart.svg`,
      have: `${ASSETS_BASE_URL}/assets/icons/have.svg`,
      sendPackage: `${ASSETS_BASE_URL}/assets/icons/SendCards/send-package-icon.svg`,
      download: `${ASSETS_BASE_URL}/assets/icons/download.svg`,
    },
    elite: {
      badge: `${ASSETS_BASE_URL}/assets/icons/elite_badge.svg`,
    },
    social: {
      twitter: `${ASSETS_BASE_URL}/assets/icons/social_twitter.png`,
      bluesky: `${ASSETS_BASE_URL}/assets/icons/social_bluesky.png`,
      reddit: `${ASSETS_BASE_URL}/assets/icons/social_reddit.png`,
      footer: {
        twitter: `${ASSETS_BASE_URL}/assets/icons/social_twitter_footer.svg`,
        bluesky: `${ASSETS_BASE_URL}/assets/icons/social_bluesky_footer.svg`,
        reddit: `${ASSETS_BASE_URL}/assets/icons/social_reddit_footer.png`,
      },
    },
  },
  
  // Logo images
  logos: {
    black: `${ASSETS_BASE_URL}/assets/logos/trademagic-logo-black.png`,
    white: `${ASSETS_BASE_URL}/assets/logos/trademagic-logo-white.png`,
    whiteSvg: `${ASSETS_BASE_URL}/assets/logos/magictrade-logo-white.svg`,
    iconLogo: `${ASSETS_BASE_URL}/assets/logos/icon-logo.svg`,
    arevakhachIcon: `${ASSETS_BASE_URL}/assets/logos/arevakhach-icon.svg`,
  },

  // Avatar images
  avatars: {
    default: `${ASSETS_BASE_URL}/assets/avatars/default-avatar.png`,
    avatar1: `${ASSETS_BASE_URL}/assets/avatars/avatar-1.png`,
    avatar2: `${ASSETS_BASE_URL}/assets/avatars/avatar-2.png`,
    avatar3: `${ASSETS_BASE_URL}/assets/avatars/avatar-3.png`,
    avatar4: `${ASSETS_BASE_URL}/assets/avatars/avatar-4.png`,
    avatar5: `${ASSETS_BASE_URL}/assets/avatars/avatar-5.png`,
    avatar6: `${ASSETS_BASE_URL}/assets/avatars/avatar-6.png`,
    byId: (id: string) => `${ASSETS_BASE_URL}/assets/avatars/${id}`,
  },
  
  // Profile avatars (alternative paths)
  profile: {
    defaultAvatar: `${ASSETS_BASE_URL}/assets/profile/default-avatar.png`,
    avatar1: `${ASSETS_BASE_URL}/assets/profile/avatar-1.png`,
  },
  
  // Background images
  backgrounds: {
    cardGlow: `${ASSETS_BASE_URL}/assets/backgrounds/card-glow-bg.png`,
    packingSplash: `${ASSETS_BASE_URL}/assets/backgrounds/packing-splash-bg.png`,
    tradePackageBackground: `${ASSETS_BASE_URL}/assets/backgrounds/trade-package-background.png`,
  },
  
  // Login/Authentication assets
  login: {
    background: `${ASSETS_BASE_URL}/assets/login/login-background.png`,
    backgroundArtist: `${ASSETS_BASE_URL}/assets/login/login-background-artist.png`,
  },
  
  // Search-related assets
  search: {
    quickSearchBg: `${ASSETS_BASE_URL}/assets/Search/quick-search-bgb.png`,
    imageComing: `${ASSETS_BASE_URL}/assets/Search/image-coming-soon.png`,
    goIcon: `${ASSETS_BASE_URL}/assets/icons/Search/icon-go.svg`,
    searchIcon: `${ASSETS_BASE_URL}/assets/icons/Search/search.png`,
    manaSymbols: {
      white: `${ASSETS_BASE_URL}/assets/icons/Search/mana-symbol-white.png`,
      blue: `${ASSETS_BASE_URL}/assets/icons/Search/mana-symbol-blue.png`,
      black: `${ASSETS_BASE_URL}/assets/icons/Search/mana-symbol-black.png`,
      red: `${ASSETS_BASE_URL}/assets/icons/Search/mana-symbol-red.png`,
      green: `${ASSETS_BASE_URL}/assets/icons/Search/mana-symbol-green.png`,
      colorless: `${ASSETS_BASE_URL}/assets/icons/Search/mana-symbol-colorless.png`,
    },
  },
  
  // Articles assets
  articles: {
    shippingGuide: `${ASSETS_BASE_URL}/assets/articles/BG_ShippingGuide.png`,
    conditionGuide: `${ASSETS_BASE_URL}/assets/articles/bg-wallpaper-articles.png`,
    conditionNM: `${ASSETS_BASE_URL}/assets/articles/Condition-NM.png`,
    conditionLP: `${ASSETS_BASE_URL}/assets/articles/Condition-LP.png`,
    conditionMP: `${ASSETS_BASE_URL}/assets/articles/Condition-MP.png`,
    conditionHP: `${ASSETS_BASE_URL}/assets/articles/Condition-HP.png`,
    howItWorks: `${ASSETS_BASE_URL}/assets/articles/bg-how-it-works.png`,
    sustainableEconomics: `${ASSETS_BASE_URL}/assets/articles/bg-sustainable-economics.png`,
    byName: (name: string) => `${ASSETS_BASE_URL}/assets/articles/${name}.png`,
  },
  
  // Card-related assets
  cards: {
    defaultBack: `${ASSETS_BASE_URL}/assets/card-back-default.png`,
    samples: {
      trygonPredator: `${ASSETS_BASE_URL}/assets/view-card/c15-236-trygon-predator.jpg`,
    },
    // Helper function to get card images from CDN using Scryfall ID
    getCardImage: (scryfallId: string, format: 'art_crop' | 'normal' | 'small' | 'large' | 'medium' = 'normal') => {
      if (!scryfallId) return `${ASSETS_BASE_URL}/assets/card-back-default.png`;
      
      // If medium is requested, fallback to small since medium doesn't exist in our CDN
      if (format === 'medium') {
        return `${CARDS_CDN_URL}/cards/small/${scryfallId}.jpg`;
      }
      
      return `${CARDS_CDN_URL}/cards/${format}/${scryfallId}.jpg`;
    },
    // Helper to ensure image URLs are from our CDN (for migration from Scryfall)
    ensureCDNUrl: (imageUrl: string | undefined): string => {
      if (!imageUrl) return `${ASSETS_BASE_URL}/assets/card-back-default.png`;
      
      // If already from our CDN, return as-is
      if (imageUrl.includes('d3dmfym8zvsq5m.cloudfront.net')) {
        return imageUrl;
      }
      
      // If it's a Scryfall URL, convert to our CDN
      if (imageUrl.includes('cards.scryfall.io') || imageUrl.includes('c1.scryfall.com')) {
        // Extract Scryfall ID from URL
        // Example: https://cards.scryfall.io/small/front/7/7/7724b978-999b-4654-9df3-58a280a7cb34.jpg
        // The ID is: 7724b978-999b-4654-9df3-58a280a7cb34
        const matches = imageUrl.match(/\/([a-f0-9]{1})\/([a-f0-9]{1})\/([a-f0-9-]+)\.jpg/);
        if (matches) {
          // The full Scryfall ID is the last part of the URL path
          const scryfallId = matches[3];
          // Determine format from URL
          let format = 'normal';
          if (imageUrl.includes('/small/')) format = 'small';
          else if (imageUrl.includes('/large/')) format = 'large';
          else if (imageUrl.includes('/art_crop/')) format = 'art_crop';
          
          const cdnUrl = `${CARDS_CDN_URL}/cards/${format}/${scryfallId}.jpg`;
          // Only log in development mode to track backend migration progress
          if (process.env.NODE_ENV === 'development') {
            console.debug('Converting Scryfall URL to CDN:', { original: imageUrl, cdn: cdnUrl });
          }
          return cdnUrl;
        }
      }
      
      // Return the URL as-is if we can't convert it
      return imageUrl;
    },
  },
  
  // Sample card images for development/demo
  sampleCards: {
    blackLotus: `${ASSETS_BASE_URL}/assets/cards/2ed-233-black-lotus+(1).png`,
    timeWalk: `${ASSETS_BASE_URL}/assets/cards/leb-84-time-walk.png`,
    llanowarElves: `${ASSETS_BASE_URL}/assets/cards/leb-211-llanowar-elves.png`,
    serraAngel: `${ASSETS_BASE_URL}/assets/cards/o90p-8-serra-angel.png`,
    territorialHellkite: `${ASSETS_BASE_URL}/assets/cards/tdc-240-territorial-hellkite.png`,
  },
  
  // Sample card crops
  sampleCardCrops: {
    abruptDecay: `${ASSETS_BASE_URL}/assets/cards-crops/mm3-146-abrupt-decay.jpg`,
    seedtime: `${ASSETS_BASE_URL}/assets/cards-crops/jud-130-seedtime.jpg`,
    chromium: `${ASSETS_BASE_URL}/assets/cards-crops/leg-224-chromium.jpg`,
    hazezonTamar: `${ASSETS_BASE_URL}/assets/cards-crops/leg-230-hazezon-tamar.jpg`,
    torstenVonUrsus: `${ASSETS_BASE_URL}/assets/cards-crops/leg-266-torsten-von-ursus.jpg`,
  },
  
  // View card assets
  viewCard: {
    trygonPredator: `${ASSETS_BASE_URL}/assets/view-card/c15-236-trygon-predator.jpg`,
    sephirothFabled: `${ASSETS_BASE_URL}/assets/view-card/fin-382-sephiroth-fabled-soldier.png`,
  },
  
  // Utility function to build custom paths
  custom: (path: string) => `${ASSETS_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`,
};

// Mana symbol mapping for text replacement
export const ManaSymbolMap: Record<string, string> = {
  '{W}': AssetUrls.icons.mana.white,
  '{U}': AssetUrls.icons.mana.blue,
  '{B}': AssetUrls.icons.mana.black,
  '{R}': AssetUrls.icons.mana.red,
  '{G}': AssetUrls.icons.mana.green,
  '{C}': AssetUrls.icons.mana.colorless,
  '{0}': AssetUrls.icons.mana.generic(0),
  '{1}': AssetUrls.icons.mana.generic(1),
  '{2}': AssetUrls.icons.mana.generic(2),
  '{3}': AssetUrls.icons.mana.generic(3),
  '{4}': AssetUrls.icons.mana.generic(4),
  '{5}': AssetUrls.icons.mana.generic(5),
  '{6}': AssetUrls.icons.mana.generic(6),
  '{7}': AssetUrls.icons.mana.generic(7),
  '{8}': AssetUrls.icons.mana.generic(8),
  '{9}': AssetUrls.icons.mana.generic(9),
  '{10}': AssetUrls.icons.mana.generic(10),
  '{11}': AssetUrls.icons.mana.generic(11),
  '{12}': AssetUrls.icons.mana.generic(12),
  '{13}': AssetUrls.icons.mana.generic(13),
  '{14}': AssetUrls.icons.mana.generic(14),
  '{15}': AssetUrls.icons.mana.generic(15),
  '{16}': AssetUrls.icons.mana.generic(16),
  '{17}': AssetUrls.icons.mana.generic(17),
  '{18}': AssetUrls.icons.mana.generic(18),
  '{19}': AssetUrls.icons.mana.generic(19),
  '{20}': AssetUrls.icons.mana.generic(20),
  '{X}': AssetUrls.icons.mana.generic(0), // X typically shown as 0
  '{T}': AssetUrls.icons.mana.tap,
  '{W/U}': AssetUrls.icons.mana.hybrid('wu'),
  '{W/B}': AssetUrls.icons.mana.hybrid('wb'),
  '{B/R}': AssetUrls.icons.mana.hybrid('br'),
  '{B/G}': AssetUrls.icons.mana.hybrid('bg'),
  '{U/B}': AssetUrls.icons.mana.hybrid('ub'),
  '{U/R}': AssetUrls.icons.mana.hybrid('ur'),
  '{R/G}': AssetUrls.icons.mana.hybrid('rg'),
  '{R/W}': AssetUrls.icons.mana.hybrid('rw'),
  '{G/W}': AssetUrls.icons.mana.hybrid('gw'),
  '{G/U}': AssetUrls.icons.mana.hybrid('gu'),
  '{W/P}': AssetUrls.icons.mana.phyrexian.white,
  '{U/P}': AssetUrls.icons.mana.phyrexian.blue,
  '{B/P}': AssetUrls.icons.mana.phyrexian.black,
  '{R/P}': AssetUrls.icons.mana.phyrexian.red,
  '{G/P}': AssetUrls.icons.mana.phyrexian.green,
};